import React, { useMemo } from 'react';

import Box from '@mui/material/Box';

import ClassIcon from '@mui/icons-material/Class';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import WorkIcon from '@mui/icons-material/Work';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DashboardIcon from '@mui/icons-material/Dashboard';

import NavigationBar from '@ts-core/components/NavigationBar/NavigationBar';
import { RankingType } from '@ts-core/utils/Constants';
import { useCourseContext } from '@ts-core/context/course';
import { Feature } from '@ts-core/utils/features';

import { useStudentAuth } from 'modules/account/hooks';
import { useCourse } from 'modules/courses/hooks';

import { useMessages } from 'modules/messages/hooks';
import MessageNotifications from 'modules/messages/components/MessageNotifications';

// const StudentNotificationsDropdown = studentNotificationsDropdownContainer(NotificationsDropdown);

const NavigationBarContainer = () => {
  const { user, onSignOut } = useStudentAuth();
  const { course } = useCourseContext();
  const { _id: courseId } = course || {};
  const { academyHasFeature } = useCourse({ courseId });
  const { unseen, previewMessagesList } = useMessages();

  const topMenuItems = useMemo(
    () => [
      {
        title: 'drawer.courses',
        to: '/courses',
        icon: ClassIcon,
      },
    ],
    []
  );

  const menuItems = useMemo(() => {
    if (!courseId) return [];
    const items = [
      {
        title: 'drawer.course.dashboard',
        to: `/${courseId}/dashboard`,
        icon: DashboardIcon,
      },
      {
        title: 'quickLink.assignments',
        icon: WorkIcon,
        to: `/${courseId}/assignments`,
      },
    ];

    if (academyHasFeature(Feature.Ranking)) {
      items.push({
        title: 'quickLink.rankings',
        icon: EqualizerIcon,
        to: `/${courseId}/rankings/${RankingType.general}`,
      });
    }

    items.push({
      title: 'quickLink.practiceSessions',
      icon: FitnessCenterIcon,
      to: `/${courseId}/practice`,
    });
    return items;
  }, [courseId, academyHasFeature]);

  return (
    <NavigationBar
      user={user}
      topMenuItems={topMenuItems}
      currentCourse={course}
      courseMenuItems={menuItems}
      onSignOut={onSignOut}
      profileUrl="/profile"
    >
      <Box display="flex" alignContent="center" justifyItems="center" height="100%">
        <MessageNotifications messages={previewMessagesList} unseen={unseen} />
      </Box>
    </NavigationBar>
  );
};

export default NavigationBarContainer;
